import React, { useState, useRef, useEffect } from "react";
import { IoNotificationsOutline } from "react-icons/io5";
import { useNotifications } from "../../context/NotificationContext";
import NotificationDropdown from "./NotificationDropdown";

const ORANGE = "#ffbe63";

export default function NotificationBell({ iconColor = ORANGE, className = "" }) {
  const [isOpen, setIsOpen] = useState(false);
  const { unreadCount } = useNotifications();
  const bellContainerRef = useRef(null);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        bellContainerRef.current &&
        !bellContainerRef.current.contains(event.target)
      ) {
        setIsOpen(false);
      }
    };

    if (isOpen) {
      document.addEventListener("mousedown", handleClickOutside);
      document.addEventListener("touchstart", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("touchstart", handleClickOutside);
    };
  }, [isOpen]);

  const displayCount = unreadCount > 99 ? "99+" : unreadCount;

  return (
    <div className={`relative inline-flex items-center ${className}`} ref={bellContainerRef}>
      <button
        onClick={() => setIsOpen((prev) => !prev)}
        className="p-1.5 rounded-lg transition-colors hover:opacity-80 relative flex items-center justify-center"
        style={{
          color: iconColor,
          background: "transparent",
          border: "none",
          fontSize: 20,
        }}
        title="Notifications"
        aria-label={`Notifications (${unreadCount} unread)`}
      >
        <IoNotificationsOutline />

        {/* Unread Count Badge */}
        {unreadCount > 0 && (
          <span
            className="absolute -top-1 -right-1 min-w-[18px] h-[18px] px-1 text-[10px] font-extrabold flex items-center justify-center rounded-full text-black leading-none shadow-md animate-pulse"
            style={{
              background: ORANGE,
            }}
          >
            {displayCount}
          </span>
        )}
      </button>

      {/* Notification Dropdown Container */}
      <NotificationDropdown isOpen={isOpen} onClose={() => setIsOpen(false)} />
    </div>
  );
}
